export enum DonorStatus {
  // for ui
  Default = 0,

  Activated = 1,
  NotActivated = 2,
  Disabled = 3
}
